import { render } from "./ProposalTemplateShow.vue?vue&type=template&id=1f05882e&scoped=true"
import script from "./ProposalTemplateShow.vue?vue&type=script&lang=js"
export * from "./ProposalTemplateShow.vue?vue&type=script&lang=js"

import "./ProposalTemplateShow.vue?vue&type=style&index=0&id=1f05882e&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f05882e"]])

export default __exports__